import { render, staticRenderFns } from "./HeaderOfPage.vue?vue&type=template&id=6334a630&"
import script from "./HeaderOfPage.vue?vue&type=script&lang=js&"
export * from "./HeaderOfPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports